export function customLocaleNumber(number) {
    const value = number.toLocaleString('pl')

    return value.length === 4 ? `${value.slice(0, 1)} ${value.slice(1)}` : value 
}